export const socialsData = {
    github: 'https://github.com/ayush-code-drops',
    linkedIn: 'https://www.linkedin.com/in/ayush-agrawal-396353159/',
    // codepen: 'https://codepen.io/cybervirus997',
    // reddit: 'https://codesandbox.io/dashboard/home?workspace=4721c2e1-372b-4efa-9c95-8850d5860204',
    // stackOverflow: 'https://stackoverflow.com/users/14299916/soumyaranjan-purohit',
}